const {
  SHOW_NOTIFICATION_DIALOG_MANUAL_0RDER,
  HIDE_NOTIFICATION_DIALOG_MANUAL_0RDER,
} = require("./action-type");

export const showNotificationDialogManualOrder = (
  title,
  content,
  button,
  url
) => {
  return {
    type: SHOW_NOTIFICATION_DIALOG_MANUAL_0RDER,
    payload: { title, content, button, url },
  };
};

export const hideNotificationDialogManualOrder = () => {
  return {
    type: HIDE_NOTIFICATION_DIALOG_MANUAL_0RDER,
  };
};
